import ProductScroller from "../../common/productscrollers.js";
import MainScroller from "./modules/mainscroller.js";
import WaitToLoad from "./modules/waittoload.js";

let thirdPartyPromise = null; 

async function init() {
    MainScroller.init();
    initExpiringScroller();
    WaitToLoad.init();

    const isThirdParty = await checkUserIsThirdParty();
    if (isThirdParty){
        const thirdPartyDialog = await loadThirdPartyDialog();
        if(thirdPartyDialog) thirdPartyDialog.open();
    }
}

function initExpiringScroller() {
    const expiringScrollerDiv = document.getElementById("expiringScroller");
    if (expiringScrollerDiv){
        const expiringProductScroller = new ProductScroller();
        expiringProductScroller.init("expiringScroller", 5, 3, 2);
    }
}

async function checkUserIsThirdParty() {
    try{
        const response = await fetch('/info/isUserThirdParty', {
            method: 'GET', 
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "Cache-Control": "no-cache" }
        });
        //if(!response.ok) throw new Error(`Error processing request: ${response.statusText}`);
        const responseJSON = await response.json();
        return responseJSON.isThirdParty;
    }catch(error){
        console.error(error);
        return null;
    }
}

async function loadThirdPartyDialog() {
	if(thirdPartyPromise){ return thirdPartyPromise.default; }
	try {
		thirdPartyPromise = await import('./dialogs/thirdparty.js');
        thirdPartyPromise.default.init();
		return thirdPartyPromise.default; // Return the default export
	} catch (error) {
		console.error("Error in loadThirdPartyDialog. Failed to load third party dialog:", error);
		thirdPartyPromise = null; // Reset to allow retry on failure
		return null;
	}
}

await init();